<style>
    .ue_modal {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99999999999;
        background-color: #FFFFFF;
        padding: 16px;
        transform: scale3d(0,0,0);
        transform-origin: 100px 100px;
    }
    .show {
        transform: scale3d(1,1,1);
    }
    .ue_modal_header {
        min-height: 16px;
        display: flex;
        flex-direction: row;
    }
    .ue_modal_header_title {
        font-weight: 600;
        font-size: 16px;
        line-height: 15px;
        color: #404455;
        flex: 1;
        text-align: center;
    }
    .ue_modal_header_close {
        width: 16px;
        height: 16px;
        background: url("./images/close_big.png") center no-repeat;
        background-size: contain;
        cursor: pointer;
        z-index: 111111;
    }
    .ue_modal_content {

    }
    .eu_modal_transition {
        transition: .4s;
    }
</style>
<script>
    import { mutations, observedRect, categories, showModal, modalTitle, modalType, modalState, modalOpened, helpIconRect, combinedArray} from '../mainStore.js';
    import CategosyTabs from './MainTabs/CategoryTabs/CategoryTabs.svelte';
    import OneItem from './OneItem.svelte';
    import Confirmation from './Confirmation.svelte';
    import Info from './Info.svelte';
    import Alert from './Alert.svelte';
    import { beforeUpdate } from "svelte";

    beforeUpdate(() => {
        window.scrollTo(0,0)
    });
    function close() {
        mutations.setShowModal(false)
    }
</script>

<div class="ue_modal {($showModal && $modalType) ? 'show' : ''} {($modalType == 'info') ? 'eu_modal_transition' : ''}" style="{$helpIconRect ? 'transform-origin: ' + ($helpIconRect.x - $observedRect.x + 8) + 'px ' + ($helpIconRect.y - $observedRect.y + 8) + 'px;' : ''}">
    <div class="ue_modal_header">
        <div class="ue_modal_header_title">
            {$modalTitle}
        </div>
        <div class="ue_modal_header_close" on:click={close}></div>
    </div>
    <div class="ue_modal_content">
        {#if ($modalType == "items")}
            <CategosyTabs categories="{$categories[$modalState]}" items={$combinedArray[$modalState]} />
        {/if}
        {#if ($modalType == "oneItem")}
            <OneItem item={$modalState} />
        {/if}
        {#if ($modalType == "confirmation")}
            <Confirmation />
        {/if}
        {#if ($modalType == "info")}
            <Info />
        {/if}
        {#if ($modalType == "alert")}
            <Alert />
        {/if}
    </div>
</div>
